import { locale, t } from '@/i18n';
export class ApiError extends Error {
  constructor(message: string, public status: number, public fieldErrors?: Record<string,string>, public code?: string) { super(message); this.name='ApiError'; }
}
async function request(path:string, options:RequestInit={}, timeoutMs?:number) {
  const headers=new Headers(options.headers);
  headers.set('Accept-Language', locale.value);
  if (options.body && !(options.body instanceof FormData)) headers.set('Content-Type','application/json');
  let response:Response;
  const timeout=AbortSignal.timeout(timeoutMs ?? (options.method && options.method!=='GET'?30000:15000));
  const signal=options.signal?AbortSignal.any([options.signal,timeout]):timeout;
  try { response=await fetch(`/api/v1${path}`, {...options, headers, signal, credentials:'same-origin'}); }
  catch(error) {
    if(options.signal?.aborted) throw error;
    if(timeout.aborted) throw new ApiError(t('common.requestTimeout'),0);
    throw new ApiError(t('common.connectionError'),0);
  }
  if (!response.ok) {
    const payload=await response.json().catch(()=>({message:t('common.operationError')}));
    if(response.status===401 && !path.startsWith('/auth/')) window.dispatchEvent(new CustomEvent('session-expired'));
    throw new ApiError(payload.message || t('common.operationError'),response.status,payload.fieldErrors,payload.code);
  }
  return response;
}
export async function api<T>(path:string, options:RequestInit={}):Promise<T> {
  const response=await request(path,options);
  return response.status===204 ? undefined as T : response.json();
}
export async function download(path:string, filename:string) {
  const blob=await fileBlob(path);const url=URL.createObjectURL(blob);
  const a=document.createElement('a');a.href=url;a.download=filename;document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
export async function fileBlob(path:string, options:RequestInit={}) {
  const response=await request(path, options, 60000);
  return response.blob();
}
